import { ChevronRight } from "lucide-react";
import { Badge } from "../ui/badge";

interface FlowItemProps {
  flow: {
    _id: string;
    name: string;
    slug: string;
    description?: string;
    status: string;
  };
  isSelected: boolean;
  onClick: () => void;
}

function getStatusVariant(
  status: string,
): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case "active":
      return "default";
    case "draft":
      return "secondary";
    case "archived":
      return "outline";
    default:
      return "secondary";
  }
}

export function FlowItem({ flow, isSelected, onClick }: FlowItemProps) {
  return (
    <div
      className={`cursor-pointer transition-all duration-200 hover:bg-muted/30 dark:hover:bg-muted/50 p-3 rounded-md mx-2 ${
        isSelected
          ? "bg-muted/50 dark:bg-muted/50 shadow-sm border border-border ring-1 ring-ring/20"
          : "hover:shadow-sm"
      }`}
      onClick={onClick}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <code className="font-mono text-xs font-medium text-foreground bg-muted px-1.5 py-0.5 rounded border border-border">
              {flow.slug}
            </code>
            <Badge
              variant={getStatusVariant(flow.status)}
              className="text-[10px] px-1.5 py-0"
            >
              {flow.status}
            </Badge>
          </div>
          <p className="text-sm font-medium text-foreground mb-1">
            {flow.name}
          </p>
          {flow.description && (
            <p className="text-xs mt-2 line-clamp-2 leading-relaxed text-muted-foreground">
              {flow.description}
            </p>
          )}
        </div>
        <ChevronRight className="h-3 w-3 text-muted-foreground flex-shrink-0 mt-1" />
      </div>
    </div>
  );
}
